import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import {
  BaseHierarchicalCrudComponent,
  GenericForm,
  ZnHierarchicalViewComponent,
} from '@zendra/shared';
import { CommonModule } from '@angular/common';
import {
  PropertyCreateDto,
  PropertyDto,
  PropertyExcelDownloadDto,
  PropertyUpdateDto,
} from 'projects/cbd-proxies/src/lib/planning/dtos/property';
import { PropertyService } from 'projects/cbd-proxies/src/lib/planning/controllers/property.service';
import { PROPERTY_CONFIG, PROPERTY_FIELDS } from './property.config';

@Component({
  selector: 'app-property',
  imports: [CommonModule, GenericForm, ZnHierarchicalViewComponent],
  providers: [ListService, PropertyService, ConfirmationService],
  templateUrl: './property.html'
})
export class Property extends BaseHierarchicalCrudComponent<
  PropertyDto,
  PropertyCreateDto,
  PropertyUpdateDto,
  PropertyExcelDownloadDto
> {
  service = inject(PropertyService);
  config = PROPERTY_CONFIG;
  fields = PROPERTY_FIELDS;

  protected prepareUpdateDto(data: any, selected: PropertyDto): PropertyUpdateDto {
    return {
      name: data.name,
      propertyCode: data.propertyCode,
      internalOrderId: data.internalOrderId,
      fomentContractId: data.fomentContractId,
      commercialAgentId: data.commercialAgentId,
      remsoft: data.remsoft,
      isDisabled: data.isDisabled,
      transportAccessTypeId: data.transportAccessTypeId,
      seasonTypeId: data.seasonTypeId,
      zoneId: data.zoneId,
      strategicCommercialZoneId: data.strategicCommercialZoneId,
      locationId: data.locationId,
      vendorId: data.vendorId,
      millId: data.millId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Property';
  }
}
